export const GET_POSTULACIONES = 'GET_POSTULACIONES'
export const GET_POSTULACIONES_SUCCESS = 'GET_POSTULACIONES_SUCCESS'
export const GET_POSTULACIONES_ERROR = 'GET_POSTULACIONES_ERROR'

export interface Postulacion {
  id: number
  nombreCompleto: string
  ultimoPuesto: string
  tituloAviso: string
  fotoURL: string
}

export interface PostulacionesState {
  postulaciones: Postulacion[] | null
  loading: boolean
  error: boolean
}

export const initialState: PostulacionesState = {
  postulaciones: null,
  loading: true,
  error: false,
}

export interface GetPostulaciones {
  type: typeof GET_POSTULACIONES
  payload: null
}

export interface GetPostulacionesSuccess {
  type: typeof GET_POSTULACIONES_SUCCESS
  payload: Postulacion[]
}

export interface GetPostulacionesError {
  type: typeof GET_POSTULACIONES_ERROR
  payload: boolean
}

export type PostulacionesActions = GetPostulaciones | GetPostulacionesSuccess | GetPostulacionesError
